import { Flex, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"
import { colorTextSubtle, colorBgButtonSubtleHovered, colorBgSucessBold, colorBgSuccessHovered } from "src/app/themes/primaryThemeDefault"
import { GreyDotIcon, GreenDotIcon } from "src/assets/icons"

interface TagProps {
    status: 'No' | 'Yes'
  }

export const ConditionalTag: React.FC<TagProps> = React.memo(
    ({ status }) => {
      const { t } = useTranslation()
  
      const getTag = (): { value: string, color: string, bgColor: string, dot: React.ReactElement } | undefined => {
        switch (status) {
          case 'No':
            return {
              value: t(`BankSetup:list.label.no`),
              color: colorTextSubtle,
              bgColor: colorBgButtonSubtleHovered,
              dot: <GreyDotIcon />,
            }
          case 'Yes':
            return {
              value: t(`BankSetup:list.label.yes`),
              color: colorBgSucessBold,
              bgColor: colorBgSuccessHovered,
              dot: <GreenDotIcon style={{ color: 'red' }} />,
            }
          default:
            return undefined
        }
      }
  
      return (
        <Flex
          align="center"
          justify="center"
          gap={4}
          style={{
            backgroundColor: getTag()?.bgColor,
            borderRadius: '27px',
            height: '28px',
            width: '52px',
          }}
        >
          {getTag()?.dot}
          <Typography.Text style={{ color: getTag()?.color, fontSize: '14px', fontWeight: 700 }}>
            {getTag()?.value}
          </Typography.Text>
        </Flex>
  
      )
    }
  )